module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAMFBMVEUAAAB3d3d4eHh6enp/f394eHh4eHh4eHh5eXl4eHh3d3d4eHh3d3d4eHh3d3d4eHiTCHm+AAAAD3RSTlMAgK8wCHDnz1Bot6dgh3jiINF7AAAAX0lEQVR42u3MxQFCUQwEwCgO23+3HBdNvt7eFDCyo9vjLp04AC6NBGB9pG2VOIrBuugkzupvJKz+R8KqiFgVEasiYlVErIqIVRGxKiJWv6KL0vVnlfjwqzrrl5Bh2N4T49MErvF2dCwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/paramIcon/空心三角形_小.png
// module id = vthp
// module chunks = 2